module.exports = __webpack_public_path__ + "static/media/coffee_hero_desktop.b79a58cf.jpg";